import CarouselItem from 'MiniSiteComponents/Carousel/Carousel.interface';
import TabsItem from './TabsItem';
import { SwiperSlide } from 'swiper/react';
import { calculateItemsNumber, cardNumberClass } from '../Carousel_Helper.interface'
import { SwiperContainer } from 'swiper/element';

interface Props {
    dir: string;
    componentId: string;
    items: CarouselItem[]
    componentTitle: string;
    isSwiperInit: boolean;
    itemstoshow: number;
}


const TabsSwiperContainer: React.FC<Props> = ({ dir, componentId, items, componentTitle, isSwiperInit }) => {

    let maxItemsPerSlide = calculateItemsNumber();
    const itemsToShowPerSlide = (maxItemsPerSlide > items.length) ? items.length : maxItemsPerSlide;
    const cardDisplayClass = cardNumberClass(itemsToShowPerSlide);
    const slidesIndexes = getFirstSlidesIndexes(items);

    const updateSwiperAutoHeight = () => {
        const id = `mst-swiper-${componentId}`;
        const swiperEl = document.getElementById(id) as SwiperContainer;
        if (swiperEl.swiper) swiperEl.swiper.updateAutoHeight();
    }
    function checkIsFirstItemInSlide(idx: number) { return (idx % itemsToShowPerSlide == 0) };

    function getFirstSlidesIndexes(items: CarouselItem[]){
        const firstItemsIndexes = items.map((item, idx) => checkIsFirstItemInSlide(idx)? idx: null);
        return firstItemsIndexes.filter(itemIdx => itemIdx != null);
    }

    return <div className={`mst-swiper ${cardDisplayClass}`}>

        <swiper-container
            init={false}
            class={`swiper-container mst-swiper-${componentId}`}
            id={`mst-swiper-${componentId}`} >

            {
                isSwiperInit &&

                slidesIndexes.map((firstItemIdx, slideIdx) =>  (
                    <SwiperSlide key={slideIdx}>

                        <TabsItem
                            componentId={componentId + "-" + slideIdx}
                            dir={dir}
                            updateSwiperAutoHeight={updateSwiperAutoHeight }
                            items={items.slice(firstItemIdx, firstItemIdx + maxItemsPerSlide)}
                            componentTitle={componentTitle} />

                    </SwiperSlide>
                ))
            }

        </swiper-container>

    </div>
}

export default TabsSwiperContainer;